import Vue from 'vue'

type Tag = 'Все' | string;

export default Vue.extend({
  inject: [
    'layoutProvider',
    'setLayoutProviderProperty',
    'globalFormProvider',
    'setGlobalFormProvider',
    'setGlobalFormProviderProperties'
  ],
  props: {
    /**
     * Поля блока
     */
    fields: {
      type: Object,
      required: false,
      default: () => {}
    },
    /**
     * Заголовок блока
     */
    title: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * Параметр отображения фильтров
     */
    useBlocksFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Лимит отображения вложенных блоков
     */
    blocksLimit: {
      type: Number,
      required: false,
      default: null
    },
    /**
     * Показывать кнопку "Показать ещё"
     */
    useShowMore: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Показать заголовок блока
     */
    useHeader: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Цвет фона обертки
     */
    useBackgroundColor: {
      type: String,
      required: false,
      default: null
    },
    /**
     * Ограничеть ширину блока
     */
    useContainer: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Отступ блок сверху
     */
    paddingTop: {
      type: Number,
      required: false,
      default: 0
    },
    /**
     * Отступ блока снизу
     */
    paddingBottom: {
      type: Number,
      required: false,
      default: 0
    },

    /**
     * * Id блока
     */
    blockId: {
      type: Number,
      default: 0
    },

    /**
     * Ссылка кнопки показать еще
     */
    showMoreLink: {
      type: String,
      default: ''
    },

    /**
     * Блок с доп параметрами
     */
    blockParams: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      /**
       * Основные поля, обработанные
       */
      mainFields: {} as { [key: string]: any },
      /**
       * Блоки, обработанные
       */
      blocks: [] as { [key: string]: any }[],
      /**
       * Теги, обработанные
       */
      tags: {} as { [key: string]: any },
      /**
       * Текущий активный тег
       */
      activeTag: 'Все' as Tag
    }
  },
  fetch () {
    try {
      this.mainFields = this.parseMainFields()
      this.blocks = this.parseBlocks()
      if (this.useBlocksFilters) {
        this.handleBlocksTags()
      }
    } catch (e: any) {
      console.error(e)
    }
  },
  computed: {
    /**
     * Лимит отображения блоков
     * @returns лимит иначе общее кол-во блоков
     */
    limit (): number {
      return this.blocksLimit || this.blocks?.length
    },
    /**
     * Блоки отфильтрованные по тегу
     */
    blocksByTag () {
      const filtered = this.activeTag === 'Все'
        ? this.blocks
        : this.blocks?.filter(block =>
          block.fields?.tags?.value.includes(this.activeTag)
        )
      return this.limit && this.limit <= filtered?.length ? filtered?.slice(0, this.limit) : filtered
    }
  },
  methods: {
    getSvgPath (id: number) {
      return `${this.$config.API_URL}/image-minifier/v1/${id}.svg`
    },
    getPngPath (id: number) {
      return `${this.$config.API_URL}/image-minifier/v1/${id}.png`
    },
    selectTag (tag: string) {
      this.activeTag = tag
    },

    // --- --- //

    /**
     * Обработка основных полей блоков
     */
    parseMainFields () {
      try {
        return this.fields?.mainFields?.reduce((acc, curr) => {
          if (!curr) { return acc }
          acc[curr.code || 'value'] = {
            value: curr.code !== 'tags' ? curr.value : (typeof curr.value === 'string' ? curr.value?.split(',') : curr.value),
            type: curr.type,
            size: curr.size,
            origin: curr.origin,
            deadline: curr.deadline
          }
          return acc
        }, {})
      } catch (error) {
        console.error(error)
      }
      return {}
    },

    // --- --- //

    /**
     * Обработка вложенного блока, преобразование массива полей в объект
     */
    parseBlock (block) {
      return {
        fields: block?.fields?.reduce((acc, curr) => {
          if (!curr) { return acc }
          acc[curr.code] =
            {
              value: curr.code !== 'tags' ? curr.value : curr.value?.split(',')?.filter(tag => !!tag),
              type: curr.type,
              size: curr.size,
              origin: curr.origin,
              deadline: curr.deadline
            }
          return acc
        }, {}),
        sort: block.sort,
        templateId: block.templateId
      }
    },

    /**
     * Обработка вложенных блоков
     */
    parseBlocks () {
      if (!this.fields?.blocks?.length) { return [] }
      return this.fields?.blocks?.map(block => this.parseBlock(block))
    },

    // --- --- //

    /**
     * Обработка тегов
     */
    handleBlocksTags () {
      this.tags['Все'] = this.blocks?.length
      this.blocks?.forEach((block) => {
        block?.fields?.tags?.value?.forEach((tag) => {
          this.tags[tag] = ++this.tags[tag] || 1
        })
      })
    },

    convertBlockFields (block) {
      return { mainFields: Object?.entries(block?.fields || {})?.map(([code, { type, size, value, origin, deadline }] : [string, any]) => ({ code, type, size, value, origin, deadline })) || [] }
    }
  }
})
